import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Avatar,
  Grid,
  Container,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BOOKINGS, LOGIN } from '../../component/common/Routes/AppRoutes';
import { VENDOR_BOOKINGS } from '../../component/common/Routes/VendorRoutes';
import { CUSTOMER_BOOKINGS } from '../../component/common/Routes/CustomerRoutes';
import '../../styles/SuccessPage.css';
import { LocalActivityOutlined } from '@mui/icons-material';
import { resetBookingDetails } from '../../redux/Bookings/BookingAction';
import CustomButton from '../../component/ui/FormFields/Button';
const InstantBookingCompleted = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pnrNumber = location.state?.pnr_number;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetBookingDetails());
  }, []);
  return (
    <Box className='success-page'>
      <Container maxWidth='md'>
        <Paper elevation={4} className='success-container fade-in'>
          {/* Success Icon */}
          <Avatar className='success-icon'>
            <CheckCircleIcon sx={{ fontSize: 50 }} />
          </Avatar>
          {/* Main Message */}
          <Typography variant='h4' className='success-title slide-down'>
            Payment Successful!
          </Typography>
          <Typography
            variant='h6'
            className='success-message slide-down slide-delay-1'
          >
            Your booking has been confirmed. Thank you for choosing our service!
          </Typography>
          <Box className='pnr-section slide-down slide-delay-2'>
            <Typography variant='h6' className='pnr-title'>
              PNR Number :
              <span
                style={{
                  color: 'primary',
                  fontWeight: 'bold',
                }}
              >
                {pnrNumber}
              </span>
            </Typography>
          </Box>
          {/* Booking Details Section */}
          <Box className='booking-details slide-down slide-delay-2'>
            <Typography variant='h6' className='booking-title'>
              Booking Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography color='text.secondary'>
                  A confirmation email has been sent to your registered email
                  address.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {/* <Typography color="text.secondary">
                  You can view your booking details in the "My Bookings"
                  section.
                </Typography> */}
              </Grid>
            </Grid>
          </Box>

          <Box className='success-button-container slide-down slide-delay-3'>
            <CustomButton
              variant='contained'
              className='orange-button'
              text={'Back To Login'}
              onClick={() => {
                navigate(LOGIN);
              }}
            />
          </Box>
          {/* Decorative Elements */}
          <Box className='decorative-container'>
            <Box className='decorative-circle-green success-icon' />
            <Box className='decorative-circle-blue success-icon' />
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default InstantBookingCompleted;